export const TEXTS = {
  LISTEN: 'Запустить веб плеер',
  CANCEL: 'Отменить',
  CONTENT: `У вас играет трек.
  Если вы запустите веб плеер, то воспроизведение трека будет остановлено.`,
  STOP_TRACK_PAYING_TITLE: 'Остановить играющую музыку?',
};
